
export const roundUp = (value, decimal) => {
    if (value && decimal) {
        return parseFloat(value).toFixed(decimal);
    }
    return value;
};